import { Modal, Space } from 'antd';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NewTicket } from '../../../model/types';
import TableSearchBar from '../../TableSearchBar';
import TicketAssociationContainer from './TicketAssociationContainer';

interface Props {
    ticket: NewTicket;
}

interface TicketMergeModalRef {
    open: () => void;
    close: () => void;
}

const styles = {
    displayNone: { display: 'none' }
};

const TicketMergeModal = forwardRef<TicketMergeModalRef, Props>(({ ticket }, ref) => {
    const { t } = useTranslation('tickets');

    const [isModalVisible, setIsModalVisible] = useState(() => !ticket);
    const [searchTerm, setSearchTerm] = useState('');

    useImperativeHandle(
        ref,
        () => ({
            open() {
                setIsModalVisible(true);
                setSearchTerm('');
            },
            close() {
                setIsModalVisible(false);
            }
        }),
        []
    );

    if (!ticket) return null;

    return (
        <Modal
            bodyStyle={{ height: '75vh', overflow: 'auto' }}
            centered
            destroyOnClose
            okButtonProps={{ style: styles.displayNone }}
            onCancel={() => setIsModalVisible(false)}
            open={isModalVisible}
            title={
                <Space size="large" wrap>
                    {t('associate.title')}
                    <TableSearchBar
                        placeholder={t('placeholders.searchMergableTickets')}
                        searchAction={(v) => setSearchTerm(v)}
                        searchTerm={searchTerm}
                        width="350px"
                    />
                </Space>
            }
            width="50%"
            style={{ minWidth: '400px' }}
        >
            <TicketAssociationContainer ticket={ticket} searchTerm={searchTerm} />
        </Modal>
    );
});

export default TicketMergeModal;

export { TicketAssociationContainer, type TicketMergeModalRef };
